import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Grid, Row } from 'react-flexbox-grid';
import { confirmAlert } from 'react-confirm-alert';
import Button from '../Button';
import TaskSignDialog from './TaskSignDialog';
import TaskRequestDialog from './TaskRequestDialog';
import TaskNaDialog from './TaskNaDialog';
import TaskTemporaryDialog from './TaskTemporaryDialog';
import TaskUndoDialog from './TaskUndoDialog';
import { projectStatusCodeMap } from '../ProjectStatusCodeMap';
import { isViewOnly, isViewOnlyOrExternalView } from '../../utils/UserInfo';
import { Checkbox, Input, Table, Button as AntdButton } from 'antd';
import ReactTooltip from 'react-tooltip';
import PaperClicpIcon from '.././PaperClipIcon';
import undo from '../.././assets/Undo.png';
import tick from '../.././assets/Tick.png';
import na from '../.././assets/na_icon.png';

import TaskImages from 'components/TaskImages';
import { SearchOutlined } from '@ant-design/icons';
import {DisabledTasks, TasksDescriptions} from './DisabledTasks';

const taskButtonPad = {
  paddingRight: '30px',
};

const firstButtonPad = {
  paddingRight: '100px',
};

export default class TaskList extends Component {
  static propTypes = {
    listTitle: PropTypes.string,
    tasks: PropTypes.array,
    onSignHandler: PropTypes.func,
    onRequestSignatureHandler: PropTypes.func,
    onMarkNaHandler: PropTypes.func,
    onMarkTempHandler: PropTypes.func,
    onUndoHandler: PropTypes.func,
    projectData: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {
      tasks: props.tasks,
      projectStatus: props.projectStatus,
      preFormSignedFl: props.preFormSignedFl,
      assetDeleteFl: props.assetDeleteFl,
      searchText: [],
      bpid: props.bpid,
      isNaDisabled: false,
    };
    this.intersperse = this.intersperse.bind(this);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      tasks: nextProps.tasks,
      isNaDisabled: false,
    });
  }

  intersperse(taskRoles, sep) {
    if (taskRoles.length === 0) {
      return [];
    }
    return taskRoles.slice(1).reduce(
        function (xs, x, i) {
          return xs.concat([sep, x.roleName]);
        },
        [taskRoles[0].roleName]
    );
  }

  render() {
    const { tasks, projectStatus, preFormSignedFl, assetDeleteFl, bpid } = this.state;

    let getPaperClip = (links) => {
 
    if (links && Array.isArray(links) && links.length > 0) {
      return <PaperClicpIcon links={links} />;
    }
 
    return null; 
  };

    // function for getting Task symbol name filter
    let getTaskName = () => {
      let newList = [
        ...new Set(
            tasks.map((task) => {
              return task.imageName;
            })
        ),
      ];

      let listOfSymbol = newList.map((task) => {
        let imageNameSplit = task.split('.')[0];
        return { text: imageNameSplit, value: task };
      });

      return listOfSymbol;
    };

    // function for getting station name
    let getStationRoleName = () => {
      let listOfRole = new Set();

      tasks.map((task) => {
        task.taskRoles.map((everyRoleArray) =>
            listOfRole.add(
                JSON.stringify({
                  text: everyRoleArray.roleName,
                  value: everyRoleArray.roleId,
                })
            )
        );
      });

      let listOfRoleArray = [...listOfRole];

      return listOfRoleArray.map((everyItem) => {
        return JSON.parse(everyItem);
      });
    };
    // keep this function in order in future to
    // get activity list function
    let getActivityList = () => {
      let newList = [
        ...new Set(tasks.map((task) => task.status || 'INCOMPLETE')),
      ];
      return newList.map((list) => {
        return { text: list, value: list };
      });
    };

    let columns = [
      {
        title: 'No.',
        dataIndex: 'no',
        align: 'center',
        width:1,


        filters: getTaskName(),
        onFilter: (value, record) => record.imageName === value,
        sorter: (a, b) => {
          return a.taskSerialNo - b.taskSerialNo;
        },

        render: (text, record) => {

          return (
              <>
                <Col
                    lg={12}
                    md={12}
                    sm={4}
                    xs={4}
                    className='tasklist--description tasklist--padding'
                    style={{ textAlign:'left',justifyContent:'start' }}
                >
                  {projectStatus !== projectStatusCodeMap['CLOSED'] &&
                  !isViewOnlyOrExternalView() &&
                  (!this.state.assetDeleteFl ||
                      this.state.assetDeleteFl === 'N') && (
                      <Col
                          lg={1}
                          md={2}
                          xs={2}
                          className='col-sm tasklist--checkbox'
                          onClick={(e) => e.stopPropagation()}

                      >
                        <Checkbox
                            id='taskCheckbox'
                            checked={record.selected}
                            className={`taskrow--checkbox ${
                                record.status === 'SIGNED' || record.status === 'NA' || record.status === 'IPSEXECUTED'
                                    ? 'disabled'
                                    : ''
                            }`}
                            onClick={() =>
                                !record.status
                                    ? this.toggleSelectedTask(record.taskId)
                                    : null ||
                                    record.status !== 'SIGNED' || record.status !== 'IPSEXECUTED' ||
                                    record.status !== 'NA' ||
                                    !record.status
                                        ? this.toggleSelectedTask(record.taskId)
                                        : null
                            }
                        />

                        {(record.status === 'SIGNED' || record.status === 'IPSEXECUTED') && (
                            <span className={'tick--signed'}>
                          <img src={tick} alt='Tick' />
                        </span>
                        )}
                        {record.status === 'NA' && (
                            <span className={'tick--na'}>
                          <img src={na} alt='NA' />
                        </span>
                        )}
                      </Col>
                  )}

                  <>
                    {record.taskSerialNo}
                  </>
                  <div style={{marginLeft:'37%'}}>
                    <TaskImages imageName={record.imageName} />
                  </div>
                </Col>
              </>
          );
        },
      },
      {
        title: 'Task',
        align: 'center',

        dataIndex: 'task',
        width: '55%',

        filterDropdown: ({
                           setSelectedKeys,
                           selectedKeys,
                           confirm,
                           clearFilters,
                         }) => {
          return (
              <div className='custom-filter-dropdown' style={{ padding: '8px' }}>
                <Input
                    autoFocus
                    placeholder='Search'
                    value={selectedKeys[0]}
                    onChange={(e) => {
                      e.preventDefault();
                      setSelectedKeys(e.target.value ? [e.target.value] : []);

                      // confirm({closeDropdown:false})
                    }}
                    onPressEnter={() => {
                      confirm();
                    }}
                    // onBlur={() => {
                    //   confirm();
                    // }}
                />

                <div>
                  <AntdButton
                      size='small'
                      type='primary'
                      style={{ width: 90, marginRight: 8 }}
                      onClick={() => {
                        confirm();
                      }}
                  >
                    Search
                  </AntdButton>
                  <AntdButton
                      size='small'
                      onClick={() => {
                        clearFilters();
                      }}

                      style={{ width: 90 }}
                  >
                    Reset
                  </AntdButton>
                </div>
              </div>
          );
        },
        filterIcon: () => {
          return <SearchOutlined />;
        },
        onFilter: (value, record) => {
          return record.description.toLowerCase().includes(value.toLowerCase());
        },

        render: (text, record) => {
          return (
              <div style={{textAlign:'left'}}>
                {/* <Col lg={12} md={12} xs={12}> */}
                {record.description}
                {/* </Col> */}
              </div>
          );
        },
      },
      {
        title: 'Role',
        dataIndex: 'role',
        align: 'center',

        filters: getStationRoleName(),
        onFilter: (value, record) => {

          let tempResult = record.taskRoles.map((everyTaskId) => {
            return everyTaskId.roleId === value;
          });

          return tempResult.includes(true);
        },

        render: (text, record) => {
          return (
              <>
              <span className='tasklist--roles tasklist--padding'style={{textAlign:'left'}}>
                {this.intersperse(record.taskRoles, '/')}
              </span>
              </>
          );
        },
      },
      {
        title: 'Activity',
        dataIndex: 'activity',
        align: 'center',

        filters: getActivityList(),
        onFilter: (value, record) => {

          if (value === 'INCOMPLETE') {
            return !record.status ;
          }
          return record.status === value;
        },
        render: (text, record) => {

          return (
              <>
                {' '}
                <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      textAlign:'left'
                    }}
                >
                  <div lg={10} md={8} xs={4} className='tasklist--padding'>
                    <div>{record.taskStatusDesc}</div>
                    <div>{record.taskTempStatusDesc}</div>
                  </div>
                  <div>
                {(() => {
                  if (projectStatus !== projectStatusCodeMap['CLOSED'] &&
                    !isViewOnlyOrExternalView() &&
                    (!this.state.assetDeleteFl || this.state.assetDeleteFl === 'N') &&
                    record.taskLock !== 'Y' &&
                    (record.status === 'REQUESTED' ||
                        record.status === 'SIGNED' || 
                        (record.status === 'NA' && !record.taskStatusDesc.includes('SYSTEM') && 
                        !record.taskStatusDesc.includes('IPS Attribute')))) {
                    return (
                      <Col lg={1} md={6} xs={6}>
                        <img
                            src={undo}
                            alt='Undo'
                            className={'undo-icon'}
                            onClick={() =>
                                this.undoTasksDialog(
                                    record.taskId,
                                    this.state.preFormSignedFl
                                )
                            }
                        />
                      </Col>
                    )
                  } else if (projectStatus !== projectStatusCodeMap['CLOSED'] &&
                    !isViewOnlyOrExternalView() &&
                    (!this.state.assetDeleteFl || this.state.assetDeleteFl === 'N') &&
                    record.taskLock !== 'Y' &&
                    (record.status === 'NA' && (record.taskStatusDesc.includes('IPS Attribute')))){
                    return (
                      <div style={{ paddingLeft: '30px', paddingRight: '30px' }}></div>
                    )
                  }else if (projectStatus !== projectStatusCodeMap['CLOSED'] &&
                    !isViewOnlyOrExternalView() &&
                    (!this.state.assetDeleteFl || this.state.assetDeleteFl === 'N') &&
                    record.taskLock !== 'Y' &&
                    (record.status === 'NA')) {
                  } else {
                    return (
                      <Col lg={1} md={6} xs={6}></Col>
                    )
                  }
                })()}
              </div>
                  <Col lg={1} md={6} xs={6}>
                    {getPaperClip(record.links)}
                  </Col>
                </div>
              </>
          );


              


        },
      },
    ];

    return (
        <Grid className='tasklist' fluid>
          {tasks.length > 0 && (
              <Table
                  // locale={{ emptyText: (<h6>No result found</h6>)}}
                  columns={columns}
                  dataSource={tasks}
                  pagination={false}
                  rowClassName={(record) => {
                    return `tasklist--row ${record.selected ? 'selected' : ''} ${
                        record.status &&
                        (record.status === 'NA' || record.status === 'SIGNED')
                            ? 'signed'
                            : ''
                    }`;
                  }}
              />
          )}
          <div className='mt-3'>
            {this.props.projectStatus !== projectStatusCodeMap['CLOSED'] &&
            (!assetDeleteFl || assetDeleteFl === 'N') &&
            ((this.props.projectStatus === projectStatusCodeMap['RELEASE'] &&
                    !isViewOnly()) ||

                this.props.projectStatus === projectStatusCodeMap['ACTIVE']
            ) && !isViewOnlyOrExternalView() && (
                <Row
                    className='task--coopenTemporaryDialogntrols'
                    style={{ align: 'center' }}
                >
                  <Col style={firstButtonPad}></Col>
                  <Col xs={4} md={2} style={taskButtonPad}>
                    <Button onClickHandler={() => this.openSignDialog()}>
                      <div style={{ paddingLeft: '30px', paddingRight: '30px' }}>
                        SIGN
                      </div>
                    </Button>
                  </Col>
                  <Col xs={4} md={2} style={taskButtonPad} ><Button id='naButton' 
                  onClickHandler={() => this.openNaDialog()} classStyle={(this.state.isNaDisabled ) ? 'disabled-button' : '' }
                  dataTip={(this.state.isNaDisabled ) ? 'At least one of the tasks you have selected cannot be marked as N/A' : '' }>
                          <div style={{ paddingLeft: '30px', paddingRight: '30px' }}>
                            N/A{' '}
                          </div>{' '}
                        </Button>
                        <ReactTooltip></ReactTooltip>
                  </Col>
                  <Col></Col>
                  <Col xs={4} md={2} style={taskButtonPad}>
                    <Button onClickHandler={() => this.openTemporaryDialog()}>
                      <div style={{ paddingLeft: '30px', paddingRight: '30px' }}>
                        {' '}
                        TEMP{' '}
                      </div>{' '}
                    </Button>
                  </Col>
                  <Col></Col>
                  <Col xs={4} md={2} style={taskButtonPad}>
                    <Button onClickHandler={() => this.openRequestDialog()}>
                      <div style={{ paddingLeft: '5px', paddingRight: '5px' }}>
                        REQ.SIGN
                      </div>
                    </Button>
                  </Col>
                  <Col></Col>
                  <Col xs={4} md={2} style={taskButtonPad}>
                    <Button onClickHandler={() => this.deselectTasks()}>
                      <div style={{ paddingLeft: '5px', paddingRight: '5px' }}>
                        DESELECT
                      </div>
                    </Button>
                  </Col>
                </Row>
            )}
          </div>
        </Grid>
    );
  }

  openSignDialog() {
    const { listTitle } = this.props;
    const selectedTasks = this.findSelectedTasks();
    if (selectedTasks.length === 0) {
      return;
    }
    const options = {
      title: listTitle,
      customUI: ({ onClose, ...props }) => (
          <TaskSignDialog
              {...props}
              tasks={selectedTasks}
              onClose={onClose}
              onAccept={() => this.signTasks(selectedTasks, onClose)}
          />
      ),
    };
    confirmAlert(options);
  }

  signTasks(tasks, callback) {
    this.props.onSignHandler(tasks, (error) => {
      if (!error) {
        this.deselectTasks();
      }
    });
    callback();
  }

  openNaDialog() {
     if(this.state.isNaDisabled){
      return;
    }
    const { listTitle } = this.props;
    const selectedTasks = this.findSelectedTasks();
    if (selectedTasks.length === 0) {
      return;
    }
    const options = {
      title: listTitle,
      customUI: ({ onClose, ...props }) => (
          <TaskNaDialog
              {...props}
              tasks={selectedTasks}
              onClose={onClose}
              onAccept={() => this.markAsNa(selectedTasks, onClose)}
          />
      ),
    };
    confirmAlert(options);
  }

  openTemporaryDialog() {
    const { listTitle } = this.props;
    const selectedTasks = this.findSelectedTasks();
    if (selectedTasks.length === 0) {
      return;
    }
    const options = {
      title: listTitle,
      customUI: ({ onClose, ...props }) => (
          <TaskTemporaryDialog
              {...props}
              tasks={selectedTasks}
              onClose={onClose}
              onAccept={() => this.markAsTemporary(selectedTasks, onClose)}
          />
      ),
    };
    confirmAlert(options);
  }

  markAsTemporary(tasks, callback) {
    this.props.onMarkTempHandler(tasks, (error) => {
      if (!error) {
        this.deselectTasks();
      }
    });
    callback();
  }

  markAsNa(tasks, callback) {
    this.props.onMarkNaHandler(tasks, (error) => {
      if (!error) {
        this.deselectTasks();
      }
    });
    callback();
  }

  openRequestDialog() {
    const { listTitle } = this.props;
    const selectedTasks = this.findSelectedTasks();
    if (selectedTasks.length === 0) {
      return;
    }
    const options = {
      title: listTitle,
      customUI: ({ onClose, ...props }) => (
          <TaskRequestDialog
              {...props}
              tasks={selectedTasks}
              onClose={onClose}
              onAccept={() => this.requestSignatures(selectedTasks, onClose)}
          />
      ),
    };
    confirmAlert(options);
  }

  requestSignatures(tasks, callback) {
    this.props.onRequestSignatureHandler(tasks, (error) => {
      if (!error) {
        this.deselectTasks();
      }
    });
    callback();
  }

  isTasksSelected(tasks){
    this.state.isNaDisabled = false;

    tasks.forEach(task => {
      let tmpTaskSelected = this.isTaskValueValid(task);
      if(tmpTaskSelected == true){
        this.setState({
          isNaDisabled: true,
        });
        // this.state.isNaDisabled = true;
        return;
      }
    })
  }


  isTaskValueValid(task){
    let projectInfo = this.getProjectInfo(this.props.projectData);
    console.log(projectInfo)
    if(projectInfo === undefined){
      return;
    }
    let description = this.getDescriptionByValueFind(task.taskMasterId)
    

    if(TasksDescriptions.SECURITY_TASK === description && projectInfo.showSecurityTasks == 1 && task.selected){
     return true;
    }

    if(TasksDescriptions.STATION_CONTRACTORS === description && projectInfo.showStationContractors == 1 && task.selected){
      return true;
    }

    if(TasksDescriptions.PC_CONTRACTORS === description && projectInfo.pcContractorSelected == 1 && task.selected){
      return true;
    }

    if(TasksDescriptions.NEW_STATION === description && projectInfo.showNewStations == 1 && task.selected){
      return true;
    }

    if(TasksDescriptions.HAZARDOUS_MATERIALS === description && projectInfo.showHazardousMaterials == 1 && task.selected && projectInfo.hazardousSelected?.includes("Asbestos")){
      return true;
    }

  }

  getProjectInfo(projectInfo){
      if(projectInfo.projectData === undefined){
        return  projectInfo;
      }
      return projectInfo.projectData.projectData;
  }

  getDescriptionByValueFind(value){
     const foundTask = Object.values(DisabledTasks.Tasks).find(task =>task.value === value)
      return foundTask ? foundTask.description : undefined
   }

  toggleSelectedTask(taskId) {
    const { tasks, projectStatus } = this.state;

    if (projectStatus === projectStatusCodeMap['CLOSED'] || isViewOnly()) {
      return null;
    }
    const updatedTasks = tasks.map((task) => {
      let updatedTask = { ...task };
      if (task.taskId === taskId) {
        updatedTask = {
          ...updatedTask,
          selected:
              projectStatus === projectStatusCodeMap['SIGNED'] ||
              projectStatusCodeMap['NA']
                  ? task.selected
                  : !task.selected,
        };
        
      }
      
      
      return updatedTask;
    });

    this.setState({
      tasks: updatedTasks,
    });
    this.isTasksSelected(updatedTasks);
  }

  findSelectedTasks() {
    const { tasks } = this.state;
    return tasks.filter((task) => task.selected === true);
  }

  findSelectedTasksById(taskId) {
    const { tasks } = this.state;
    const value = tasks.filter((task) => task.taskId === taskId);
    return value;
  }

  deselectTasks() {
    const { tasks } = this.state;

    const updatedTasks = tasks.map((task) => {
      task.selected = false;
      return task;
    });

    this.setState({
      tasks: updatedTasks,
    });
  }

  undoTasks(tasks, callback) {
    this.props.onUndoHandler(tasks, (error) => {
      if (!error) {
        this.deselectTasks();
      }
    });
    callback();
  }

  undoTasksDialog(taskId, fl) {
    const { listTitle } = this.props;
    const selectedTasks = this.findSelectedTasksById(taskId);

    if (selectedTasks.length === 0) {
      return;
    }
    const options = {
      title: listTitle,
      customUI: ({ onClose, ...props }) => (
          <TaskUndoDialog
              {...props}
              tasks={selectedTasks}
              onClose={onClose}
              onAccept={() => this.undoTasks(selectedTasks, onClose)}
          />
      ),
    };
    confirmAlert(options);
  }
}
